<template>
  <el-dialog :title="$t('common.confirm')" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <div style="text-align:center">
      <p>{{ $t('chainSupplierCatalog.confirmDeleteCatalog') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteChainSupplierCatalog">{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteChainSupplierCatalog } from '@/api/admin/chainSupplierCatalog/chainSupplierCatalogApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteChainSupplierCatalog',
  data() {
    return {
      dialogVisible: false,
      deleteChainSupplierCatalogInfo: {
        catalogId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(chainSupplierCatalog) {
      this.dialogVisible = true
      this.deleteChainSupplierCatalogInfo = {
        catalogId: chainSupplierCatalog.catalogId,
        shopId: getShopId()
      }
    },
   async deleteChainSupplierCatalog() {
      const {code, msg} = await deleteChainSupplierCatalog(this.deleteChainSupplierCatalogInfo)
      if (code == 0) {
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } else {
        this.$message.error(msg)
      }
    },
    handleClose() {
      this.deleteChainSupplierCatalogInfo = {
        catalogId: '',
        shopId: ''
      }
    }
  }
}
</script>